/**
 * Google Ads “Page view” conversion (paired with `gtag_report_conversion` in `public/index.html`).
 * Use from buttons/links: `onClick={() => gtagReportConversion("/path")}` or without URL to stay on page.
 * @param {string} [url] — If set, navigate after the conversion ping (Google’s click pattern).
 * @returns {false} — For use as `return gtagReportConversion(href)` in legacy `onclick` handlers.
 */
const PAGE_VIEW_SEND_TO = "AW-11509160772/9mt1CNjugvoZEMS2_-8q";

export function gtagReportConversion(url) {
  if (typeof window === "undefined") return false;

  const globalFn = window.gtag_report_conversion;
  if (typeof globalFn === "function") {
    return globalFn(url);
  }

  const gtag = window.gtag;
  if (typeof gtag !== "function") return false;

  const callback = function () {
    if (typeof url !== "undefined" && url != null && String(url).length > 0) {
      window.location = url;
    }
  };

  gtag("event", "conversion", {
    send_to: PAGE_VIEW_SEND_TO,
    value: 1.0,
    currency: "INR",
    event_callback: callback,
  });
  return false;
}

/**
 * Same conversion as Google’s snippet, but `event_callback` uses React Router (no full reload).
 * @param {(to: string) => void} navigate — `navigate` from `useNavigate()`
 * @param {string} path — e.g. `/register`
 */
export function gtagReportConversionThenNavigate(navigate, path) {
  if (typeof window === "undefined") return;
  const gtag = window.gtag;
  const to = path != null ? String(path) : "";
  if (typeof gtag !== "function" || !to) {
    if (typeof navigate === "function") navigate(to || "/");
    return;
  }
  gtag("event", "conversion", {
    send_to: PAGE_VIEW_SEND_TO,
    value: 1.0,
    currency: "INR",
    event_callback: () => {
      if (typeof navigate === "function") navigate(to);
    },
  });
}
